module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.size
  }, [_c('div', {
    staticClass: "rais-box"
  }, [_c('div', {
    staticClass: "rais-box-photo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'show_fundraising',
        params: {
          id: _vm.project.id,
          title: _vm.project.title.replace(/ /g, '-')
        }
      }
    }
  }, [(_vm.project.photo.thumb.url) ? _c('img', {
    attrs: {
      "src": _vm.$server_url + _vm.project.photo.thumb.url
    }
  }) : _c('img', {
    attrs: {
      "src": require("assets/img/projectPlaceholder.png")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "rais-box-text"
  }, [_c('router-link', {
    staticClass: "category",
    attrs: {
      "to": {
        name: 'fundraising',
        query: {
          category: _vm.project.category.name
        }
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.project.category.name) + "\n      ")]), _vm._v(" "), (_vm.showStatus) ? _c('span', {
    staticClass: "days-left pull-right"
  }, [_vm._v("\n        " + _vm._s(_vm.$t(("project.status." + (_vm.project.status)))) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "title",
    attrs: {
      "to": {
        name: 'show_fundraising',
        params: {
          id: _vm.project.id,
          title: _vm.project.title.replace(/ /g, '-')
        }
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.project.title) + "\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "author",
    attrs: {
      "to": {
        name: 'show_profile',
        params: {
          id: _vm.project.user.id
        }
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.project.user.full_name) + "\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "short-desc"
  }, [_vm._v(_vm._s(_vm.project.description))]), _vm._v(" "), _c('p', {
    staticClass: "allready-raised"
  }, [_vm._v("$" + _vm._s(_vm.completion * 100))]), _vm._v(" "), _c('div', {
    staticClass: "bar-goal"
  }, [_c('div', {
    staticClass: "bar-raised",
    style: ({
      width: _vm.completion + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "days-left"
  }, [(_vm.project.deadline && _vm.project.status === 'published') ? _c('div', [_vm._v("\n          " + _vm._s(_vm._f("daysLeft")(_vm.project.deadline)) + " " + _vm._s(_vm.$t('project.daysLeft')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.project.deadline && _vm.project.status === 'successful') ? _c('div', [_vm._v(_vm._s(_vm.$t('project.ended')))]) : _vm._e(), _vm._v(" "), (!_vm.project.deadline) ? _c('div', [_vm._v(_vm._s(_vm.project.duration + ' ' + _vm.$t('project.daysLeft')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "goal"
  }, [_vm._v(_vm._s(_vm._f("currencySymbol")(_vm.project.currency)) + _vm._s(_vm._f("price")(_vm.project.to_collect)) + " " + _vm._s(_vm.$t('project.goal')))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c13c882"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Tiles/Fundraising.vue
// module id = 798
// module chunks = 1